import { TVillageOffersType } from '../constants/base';

export function isResaleOnlyOrNoOffers(offersType: TVillageOffersType | undefined) {
  return !offersType || offersType === 'resale';
}
